import React from 'react';
import { Col, Row } from 'react-bootstrap';

import useGlobal from '../../../store';
import AutofacturacionTicketList from './AutofacturacionTicketList';
import SearchByDatesAndKeyword from '../../../shared/SearchByDatesAndKeyword';
import AutofacturacionListToolbarActions from './components/AutofacturacionListToolbarActions';

const mapState = (store) => {
  return store.external.receptores.autofacturacion.list;
};

const mapActions = (actions) => {
  return { ...actions.external.receptores.autofacturacion.list };
};

const Autofacturacion = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);
  const { from, to } = state.filters;

  const selectedRowKeys = [];

  const handleOnDateChange = (values) => {
    actions.paginate(values);
  };

  const handleOnKeywordChange = (search) => {
    actions.paginate({ search });
  };

  const handleOnRowClick = (data) => {
    props.history.push({
      pathname: `/ext/receptores/autofacturacion/tickets/${data.id}/info`,
      state: {
        data: {
          ...data,
        },
      },
    });
  };

  return (
    <>
      <Row>
        <Col
          sm="auto"
          md="9"
          className="mb-2"
        >
          {selectedRowKeys.length === 0 && (
            <SearchByDatesAndKeyword
              from={from}
              to={to}
              onDateChange={handleOnDateChange}
              onKeywordChange={handleOnKeywordChange}
            />
          )}
        </Col>
        <Col
          md="3"
          className="text-right"
        >
          <AutofacturacionListToolbarActions />
        </Col>
      </Row>

      <AutofacturacionTicketList onRowClick={handleOnRowClick} />
    </>
  );
};

export default Autofacturacion;
